export default class CommentController {
  static list (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/comment/list', 'post', params, axiosOption, httpOption);
  }

  static view (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/comment/view', 'get', params, axiosOption, httpOption);
  }

  static export (sender, params, fileName) {
    return sender.download('/admin/app/comment/export', params, fileName);
  }

  static add (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/comment/add', 'post', params, axiosOption, httpOption);
  }

  static update (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/comment/update', 'post', params, axiosOption, httpOption);
  }

  static delete (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/comment/delete', 'post', params, axiosOption, httpOption);
  }

  static updateAudit (sender, params, axiosOption, httpOption) {
    return sender.doUrl('/admin/app/comment/updateAudit', 'post', params, axiosOption, httpOption);
  }
}
